var render = function () {
  var _vm$lockCondition;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "reward-card-main-image"
  }, [_vm.deepGet(_vm.rewardsCard, 'config.main_image') ? _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.deepGet(_vm.rewardsCard, 'config.main_image')
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "s-p-3 overflow-x-hidden"
  }, [_vm.rewardsCardStatus === 1 ? _c('Toast', {
    staticClass: "mb-3",
    staticStyle: {
      "max-width": "none"
    },
    attrs: {
      "variant": "error"
    }
  }, [_vm._v("尚未開始")]) : _vm._e(), _vm.rewardsCardStatus === 3 ? _c('Toast', {
    staticClass: "mb-3",
    staticStyle: {
      "max-width": "none"
    },
    attrs: {
      "variant": "error"
    }
  }, [_vm._v("無法使用")]) : _vm._e(), _c('b-carousel', {
    ref: "rewardsCardCarousel",
    staticClass: "reward-card__carousel mb-4",
    attrs: {
      "interval": 0,
      "indicators": _vm.cards.length > 1 && _vm.rewardsCard.show_used_point !== 2,
      "no-wrap": true
    },
    model: {
      value: _vm.slide,
      callback: function callback($$v) {
        _vm.slide = $$v;
      },
      expression: "slide"
    }
  }, [_vm._l(_vm.cards, function (card) {
    return _c('b-carousel-slide', {
      key: card.id,
      scopedSlots: _vm._u([{
        key: "img",
        fn: function fn() {
          return [_c('b-card', {
            staticClass: "border border-1 reward-card",
            attrs: {
              "no-body": ""
            }
          }, [_c('div', {
            staticClass: "\n                reward-card__header\n                px-3\n                d-flex\n                justify-content-between\n                align-items-center\n              "
          }, [_c('div', {
            staticClass: "reward-card__title"
          }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
            staticClass: "d-flex align-items-center"
          }, [_c('span', {
            staticClass: "reward-card__header__point"
          }, [_vm._v(_vm._s(_vm.availablePoints))]), _c('span', {
            staticClass: "small ml-2"
          }, [_vm._v("點")])])]), _vm.rewardsCard.show_used_point !== 2 ? _c('div', {
            staticClass: "reward-card__body p-2"
          }, _vm._l(_vm.rewardsCard.point_number, function (i) {
            return _c('div', {
              key: i,
              staticClass: "reward-card__body__point p-2",
              class: i <= card.point ? 'active' : '',
              style: _vm.pointWidth
            }, [_c('div', {
              staticClass: "\n                    reward-card__body__point__stamp\n                    d-flex\n                    justify-content-center\n                    align-items-center\n                  "
            }, [i <= card.point ? _c('img', {
              attrs: {
                "src": require("./images/stamp.svg")
              }
            }) : i <= card.point + card.usedPoint ? _c('span', {
              staticClass: "s-text-xs"
            }, [_vm._v("已使用")]) : _c('span', [_vm._v(_vm._s(i))])])]);
          }), 0) : _vm._e()])];
        },
        proxy: true
      }], null, true)
    });
  }), _vm.cards.length > 1 && _vm.rewardsCard.show_used_point !== 2 ? _c('button', {
    staticClass: "carousel-control-prev",
    attrs: {
      "disabled": _vm.slide === 0,
      "href": "#",
      "role": "button"
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('span', {
    staticClass: "carousel-control-prev-icon"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next slide")])]) : _vm._e(), _vm.cards.length > 1 && _vm.rewardsCard.show_used_point !== 2 ? _c('button', {
    staticClass: "carousel-control-next",
    attrs: {
      "disabled": _vm.slide === _vm.cards.length - 1,
      "href": "#",
      "role": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('span', {
    staticClass: "carousel-control-next-icon"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next slide")])]) : _vm._e()], 2), _vm.shouldDisplayBranchList ? _c('ShopSelection', {
    ref: "shopSelection",
    attrs: {
      "branch-provider": _vm.branchProvider,
      "show-branch-code": _vm.showBranchCode,
      "placeholder": _vm.displayPlaceholder
    },
    on: {
      "loading": _vm.handleBranchesAreLoading,
      "loaded": _vm.handleBranchesAreLoaded,
      "selectedShop": _vm.handleShopIsSelected
    },
    model: {
      value: _vm.shopId,
      callback: function callback($$v) {
        _vm.shopId = $$v;
      },
      expression: "shopId"
    }
  }) : _vm._e(), _vm.fetchSuccess ? _c('div', {
    staticClass: "reward-award mb-3"
  }, [_c('div', {
    staticClass: "reward-tabs"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('a', {
      key: tab.key,
      staticClass: "reward-tab",
      class: {
        'active-tab': _vm.query.tab && _vm.query.tab === tab.key
      },
      on: {
        "click": function click($event) {
          _vm.query.tab = tab.key;
        }
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " ")]);
  }), 0), _vm.query.tab == 'gifts' && _vm.tabIsVisible('gifts') ? [_vm._l(_vm.gifts, function (gift) {
    return _c('b-card', {
      key: gift.id,
      staticClass: "reward-award-item d-flex flex-nowrap flex-row mt-3",
      attrs: {
        "no-body": ""
      }
    }, [_c('div', {
      staticClass: "reward-award-item__image position-relative",
      class: {
        'reward-award-item__image--empty': !gift.image
      }
    }, [_c('img', {
      staticClass: "img-fluid",
      class: {
        'reward-award-item__image--locked': _vm.redemptionOrderType === 'sequential' && gift.is_locked
      },
      attrs: {
        "src": gift.image
      }
    }), gift.target_type === 'redeem_code_bundle' ? _c('button', {
      staticClass: "reward-preview-btn-overlay",
      on: {
        "click": function click($event) {
          return _vm.handlePreviewCoupon(gift);
        }
      }
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
      }
    })])]) : _vm._e()]), _c('div', {
      staticClass: "flex-fill p-2 d-flex flex-column"
    }, [_c('div', {
      staticClass: "reward-award-item__title flex-fill"
    }, [_vm._v(" " + _vm._s(gift.name) + " ")]), _c('div', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('div', {
      staticClass: "reward-award-item__point d-flex align-items-center"
    }, [_c('div', {
      staticClass: "reward-award-item__stamp mr-2"
    }, [_c('img', {
      attrs: {
        "src": require("./images/stamp.svg")
      }
    })]), _c('div', [_vm._v(_vm._s(gift.point))])]), _vm.showRewardBtn ? [gift.is_locked ? _c('button', {
      staticClass: "\n                    s-btn s-liff-theme-btn-outline s-btn-xs\n                    reward-award-item__button\n                    disabled\n                  ",
      on: {
        "click": function click($event) {
          return _vm.handleLockConditionClick(gift);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.redemptionOrderType === 'sequential' ? '達成條件後解鎖' : '尚未解鎖') + " ")]) : !_vm.doesFindProduct(gift.target_id) ? _c('button', {
      staticClass: "\n                    s-btn s-liff-theme-btn-outline s-btn-xs\n                    reward-award-item__button\n                  ",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(" 查無商品 ")]) : !_vm.giftIsInStock(gift) ? _c('button', {
      staticClass: "\n                    s-btn s-liff-theme-btn-outline s-btn-xs\n                    reward-award-item__button\n                  ",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(" 庫存不足 ")]) : _vm.couponReachedLimit(gift) ? _c('button', {
      staticClass: "\n                    s-btn s-liff-theme-btn-outline s-btn-xs\n                    reward-award-item__button\n                  ",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(" 已兌換 ")]) : gift.point > _vm.point ? _c('button', {
      staticClass: "\n                    s-btn s-liff-theme-btn-outline s-btn-xs\n                    reward-award-item__button\n                  ",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(" 點數不足 ")]) : _c('button', {
      staticClass: "\n                    s-btn s-liff-theme-btn-outline s-btn-xs\n                    reward-award-item__button\n                  ",
      on: {
        "click": function click($event) {
          return _vm.handleExchange(gift);
        }
      }
    }, [_vm._v(" 兌換 ")])] : _vm._e()], 2)])]);
  }), _vm.fetchSuccess ? _c('PointPagination', {
    attrs: {
      "totalPage": _vm.totalPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }) : _vm._e()] : _vm.query.tab == 'received' && _vm.tabIsVisible('received') ? [_vm.eventCodeSetted ? _c('ExchangeRecords', {
    attrs: {
      "event-code": _vm.eventCode
    }
  }) : _vm._e()] : _vm.query.tab == 'point-logs' && _vm.tabIsVisible('point-logs') ? [_vm.eventCodeSetted ? _c('PointLogs', {
    attrs: {
      "event-code": _vm.eventCode,
      "force-source-type": 'rewards_card_point'
    }
  }) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm.fetching ? _c('Loading') : _vm._e(), _c('Popup', {
    ref: "popupConfirm",
    attrs: {
      "panelHeight": "auto"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" 是否確定要使用 "), _c('span', {
    staticClass: "s-primary"
  }, [_vm._v(_vm._s(_vm.popup.point))]), _vm._v(" 點 ")]), _vm.branchCode ? _c('div', {
    staticClass: "s-mb-5 s-text-center"
  }, [_vm._v(" 兌換店號：" + _vm._s(_vm.branchCode) + " ")]) : _vm._e(), _c('div', {
    staticClass: "s-mb-5 s-text-center"
  }, [_vm._v(" 請注意，點數一經使用即無法取消 ")]), _c('div', {
    staticClass: "s-flex s-space-x-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.popupConfirm.close();
      }
    }
  }, [_vm._v(" 取消 ")]), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(" 確定 ")])])]), _c('Popup', {
    ref: "popupBranchCode",
    attrs: {
      "panelHeight": "auto"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("請輸入店號")]), _c('div', {
    staticClass: "s-mb-5 s-text-center"
  }, [_vm._v(" 請輸入店號以完成兌換 ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.branchCode,
      expression: "branchCode"
    }],
    staticClass: "s-mb-5 s-text-center branch-code-input",
    attrs: {
      "placeholder": "請輸入店號"
    },
    domProps: {
      "value": _vm.branchCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.branchCode = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "s-flex s-space-x-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.popupBranchCode.close();
      }
    }
  }, [_vm._v(" 取消 ")]), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.branchCode
    },
    on: {
      "click": _vm.handleBranchCodeConfirm
    }
  }, [_vm._v(" 確定 ")])])]), _c('b-modal', {
    attrs: {
      "id": "modal-product",
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "bodyClass": "p-0"
    }
  }, [_vm.selectProdcut ? _c('div', {
    staticClass: "purchase",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "p-3 border-bottom"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    staticClass: "img-fluid mr-2",
    attrs: {
      "src": _vm.selectProdcut.image
    }
  })])]), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.selectProdcut.title))]), _c('div', {
    staticClass: "point d-flex align-items-center"
  }, [_c('div', {
    staticClass: "reward-award-item__stamp mr-2"
  }, [_c('img', {
    attrs: {
      "src": require("./images/stamp.svg")
    }
  })]), _c('div', [_vm._v(_vm._s(_vm.selectProdcut.point))])])])])]), _c('div', {
    staticClass: "p-3"
  }, _vm._l(_vm.selectProdcut.skus, function (sku) {
    return _c('b-button', {
      key: sku.id,
      staticClass: "m-2",
      class: {
        'active': _vm.selectSku && _vm.selectSku.id === sku.id
      },
      attrs: {
        "variant": "outline-dark",
        "disabled": _vm.stockCheckIsEnabled && sku.quantity === 0
      },
      on: {
        "click": function click($event) {
          _vm.selectSku = sku;
        }
      }
    }, [_vm._v(" " + _vm._s(sku.sku_name) + " ")]);
  }), 1), _c('div', {
    staticClass: "p-3"
  }, [_vm.needBranchCode ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.branchCode,
      expression: "branchCode"
    }],
    staticClass: "form-control s-mb-5 s-text-center",
    attrs: {
      "placeholder": "請輸入店號"
    },
    domProps: {
      "value": _vm.branchCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.branchCode = $event.target.value;
      }
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "size": "lg",
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-product');
      }
    }
  }, [_vm._v(" 取消 ")])], 1), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "size": "lg",
      "variant": "primary",
      "disabled": !_vm.selectSku
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(" 確定 ")])], 1)])])]) : _vm._e()]), _c('Popup', {
    ref: "popupLockCondition",
    staticClass: "popup-lock-condition",
    attrs: {
      "panelHeight": "auto",
      "noActions": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("解鎖條件")]), _c('div', {
    staticClass: "s-mb-5 s-text-center"
  }, [_vm._v(" 兌換「" + _vm._s((_vm$lockCondition = _vm.lockCondition) === null || _vm$lockCondition === void 0 ? void 0 : _vm$lockCondition.name) + "」後解鎖 ")])])], 1), _vm.fetchSuccess ? _c('div', {
    staticClass: "reward-notice s-p-3"
  }, [_c('div', {
    staticClass: "reward-notice__title"
  }, [_vm._v("注意事項")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.rewardsCard.memo)
    }
  })]) : _vm._e(), _c('coupon-modal', {
    ref: "couponModal",
    attrs: {
      "coupon": _vm.selectedCoupon
    }
  }), _c('coupon-modal', {
    ref: "tempCouponModal",
    attrs: {
      "redeem-code-bundle-id": _vm.redeemCodeBundleId,
      "confirm-from-outside": true
    },
    on: {
      "confirmFromOutside": _vm.handleBasicExchange
    }
  }), _c('coupon-modal', {
    ref: "previewCouponModal",
    attrs: {
      "preview-mode": true,
      "redeem-code-bundle-id": _vm.previewRedeemCodeBundleId
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }